import { render, staticRenderFns } from "./learn.layout.vue?vue&type=template&id=0d98b22d&"
import script from "./learn.layout.vue?vue&type=script&lang=ts&"
export * from "./learn.layout.vue?vue&type=script&lang=ts&"
import style0 from "./learn.layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports